import React from 'react';
import Head from 'next/head';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import styles from '../styles/SellYourParts.module.css';
import Link from 'next/link';

function SellYourParts() {
  return (
    <>
      <Head>
        <title>Sell Us Your Parts | Fitness and Exercise Equipment Repair Parts</title>
        <meta
          name="description"
          content={'Make Money Selling Your Extra Parts on FitnessRepairParts.com!'}
        />
        <meta httpEquiv="content-language" content="en-us" />
      </Head>
      <div>
        <h1>Make Money Selling Your Extra Parts on FitnessRepairParts.com!</h1>
        <p className={styles.text}>
          FRP offers two methods of selling your excess parts. Part Buyouts allow you to immediately sell your parts 
          and our Marketplace solution will allow you to list those items for sale alongside our parts and reach our customers. 
          Each year millions of visitors come shop on our site in search of parts for their machines, you can reach those same 
          potential customers with the items you need to sell. Here are some key differences between the two programs.
        </p>
        <TableContainer sx={{ padding: '0px 5%' }}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>

                </TableCell>
                <TableCell>
                  <a href='/part_buyout.php'>Part Buyout</a>
                </TableCell>
                <TableCell>
                  <Link href='/marketplace/about'>Marketplace</Link>
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              <TableRow>
                <TableCell>
                  Getting Paid:
                </TableCell>
                <TableCell>
                  FRP typically pays 10% of list price up front when we receive the parts
                </TableCell>
                <TableCell>
                  FRP charges a 15% commission on sales, meaning <strong>you keep 85% of the sale price</strong> when items are sold
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell>
                  Used & Refurbished:
                </TableCell>
                <TableCell>
                  FRP does NOT accept used and refurbished parts
                </TableCell>
                <TableCell>
                  You <strong>CAN sell used and refurbished</strong> parts
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell>
                  Inventory:
                </TableCell>
                <TableCell>
                  FRP warehouses the parts
                </TableCell>
                <TableCell>
                  You warehouse the parts
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell>
                  Shipping:
                </TableCell>
                <TableCell>
                  FRP ships the parts to the customer
                </TableCell>
                <TableCell>
                  You ship the parts to the customer
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell>
                  Customer Service:
                </TableCell>
                <TableCell>
                  FRP deals with customer service issues
                </TableCell>
                <TableCell>
                  You deal with the customers
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell>
                  Returns:
                </TableCell>
                <TableCell>
                  FRP handles returns & refunds
                </TableCell>
                <TableCell>
                  You handle returns & refunds
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell>
                  Pricing of the Part:
                </TableCell>
                <TableCell>
                  FRP sets the retail price of the part
                </TableCell>
                <TableCell>
                  You set the price of the parts
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
        <p className={styles.text}>
          With Marketplace you&apos;ll have more responsibilities, but can also <strong>make more profit!</strong>
        </p>
        <p className={styles.text}>
          You&apos;ll also have a store page on our site dedicated to the items that you have listed for sale.
        </p>
        <h2 className={styles.call_to_action_links}>
          <a href='/part_buyout.php'>To Start a Part Buyout Click Here</a>
        </h2>
        <h2 className={styles.call_to_action_links}>
          <Link href='/marketplace/about'>To Open a Marketplace Account Click Here</Link>
        </h2>
      </div>
    </>
  );
};

export default SellYourParts;